import { useEffect, useState } from 'react';

export const useIsDarkMode = () => {
	const [isDark, setIsDark] = useState(() => {
		if (typeof window === 'undefined') return false;

		// First check for dark class on html/body element
		const hasWebsiteDarkMode =
			document.documentElement.classList.contains('dark') ||
			document.body.classList.contains('dark');

		// If website doesn't specify theme, fall back to system preference
		if (!hasWebsiteDarkMode) {
			return window.matchMedia('(prefers-color-scheme: dark)').matches;
		}

		return hasWebsiteDarkMode;
	});

	useEffect(() => {
		if (typeof window === 'undefined') return;

		const updateTheme = () => {
			const hasWebsiteDarkMode =
				document.documentElement.classList.contains('dark') ||
				document.body.classList.contains('dark');
			setIsDark(hasWebsiteDarkMode);
		};

		// Watch for changes in DOM
		const observer = new MutationObserver(mutations => {
			mutations.forEach(mutation => {
				if (mutation.attributeName === 'class') {
					updateTheme();
				}
			});
		});

		// Observe both html and body elements
		observer.observe(document.documentElement, { attributes: true });
		observer.observe(document.body, { attributes: true });

		// Also listen for system preference changes as fallback
		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		const systemPreferenceHandler = (e: any) => {
			const hasWebsiteDarkMode =
				document.documentElement.classList.contains('dark') ||
				document.body.classList.contains('dark');
			if (!hasWebsiteDarkMode) {
				setIsDark(e.matches);
			}
		};

		mediaQuery.addEventListener('change', systemPreferenceHandler);

		// Initial check
		updateTheme();

		// Cleanup
		return () => {
			observer.disconnect();
			mediaQuery.removeEventListener('change', systemPreferenceHandler);
		};
	}, [setIsDark]);

	return isDark;
};
